import currencyCodes from '../../../data/currencyCodes';
import { FORM_NAME } from '../data/constants';
import { FormBuilder, FormShape, PaymentFormTransformer } from '../types';

const getPaymentForm = (
	props: PaymentFormTransformer,
	name = FORM_NAME.payment,
) => {
	const { fields: paymentFields, fieldValues, mediaByLocator } = props;

	currencyCodes;

	const fields = [];

	if (paymentFields) {
		fields.push(...paymentFields);
	}

	return {
		[name]: {
			fields,
			mediaByLocator,
			values: fieldValues,
		} as FormBuilder,
	} as FormShape<FormBuilder>;
};

export interface PaymentFormValues {
	payment: {
		amountCurrency: string;
		amount: string;
		policyholderLocator?: string;
		policyLocator?: string;
		[configuredFields: string]: string | boolean | number | string[] | number[];
	};
}

export interface PaymentDirtyFields {
	payment?: {
		[x: string]: boolean | boolean[];
		currency?: boolean;
		amount?: boolean;
		policyholderLocator?: boolean;
		policyLocator?: boolean;
	};
}

export default getPaymentForm;
